// Uniform number formatting across the app.
// < 10 000  -> full with thousand separators (money: 2 decimals, counts: 0)
// >= 10 000 -> short form: 10k, 250k, 1.2M, 3.4B (max 1 decimal, no trailing .0)

export function formatShort(n) {
  const num = Number(n || 0);
  const abs = Math.abs(num);
  if (abs < 10000) return null; // not shortened
  const sign = num < 0 ? "-" : "";
  const trim = (v, suffix) => {
    let s = v.toFixed(1);
    if (s.endsWith(".0")) s = s.slice(0, -2);
    return sign + s + suffix;
  };
  if (abs >= 1e9) return trim(abs / 1e9, "B");
  if (abs >= 1e6) return trim(abs / 1e6, "M");
  return trim(abs / 1e3, "k");
}

export function formatFull(n, money = false) {
  const num = Number(n || 0);
  const opts = money
    ? { minimumFractionDigits: 2, maximumFractionDigits: 2 }
    : { maximumFractionDigits: 0 };
  const body = Math.abs(num).toLocaleString("en-US", opts);
  const sign = num < 0 ? "-" : "";
  return money ? `${sign}$${body}` : `${sign}${body}`;
}

// String form (for template strings / non-interactive contexts).
export function formatAmount(n, money = true) {
  const short = formatShort(n);
  if (!short) return formatFull(n, money);
  const num = Number(n || 0);
  const sign = num < 0 ? "-" : "";
  const abs = short.replace("-", "");
  return money ? `${sign}$${abs}` : `${sign}${abs}`;
}
